import React, { useState } from 'react';
import { Card, Form, Input, InputNumber, Select, TimePicker, Button, message, Alert, Typography } from 'antd';
import { PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../../services/api';

const { Title, Text } = Typography;

const DOWS = [
  { value: 0, label: 'Domingo' }, { value: 1, label: 'Segunda' },
  { value: 2, label: 'Terça' }, { value: 3, label: 'Quarta' },
  { value: 4, label: 'Quinta' }, { value: 5, label: 'Sexta' },
  { value: 6, label: 'Sábado' },
];

// Form pra criar time adicional pro admin_user (multi-team). So funciona se
// pelo menos um dos times atuais tem allow_multi_team=true — validado no backend.
export default function TeamCreate() {
  const nav = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const submit = async (values) => {
    setLoading(true);
    try {
      const r = await api.post('/organizer/teams', {
        team_name: values.team_name,
        day_of_week: values.day_of_week,
        game_time: values.game_time.format('HH:mm'),
        players: values.players || 15,
        goalkeepers: values.goalkeepers || 2,
      });
      // Substitui JWT — o backend ja criou tudo e trocou pro time novo.
      // Hard redirect via window.location.href garante que a proxima pagina
      // arranca do zero com o token novo (nav+reload separados deixavam
      // cache/state stale do time anterior aparecer misturado).
      localStorage.setItem('token', r.data.token);
      localStorage.setItem('user', JSON.stringify(r.data.user));
      message.success(`Time "${values.team_name}" criado! Entrando...`);
      window.location.href = '/team-config';
    } catch (e) {
      message.error(e?.response?.data?.message || 'Erro ao criar time');
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '32px auto', padding: 16 }}>
      <Button icon={<ArrowLeftOutlined />} type="text" onClick={() => nav(-1)} style={{ marginBottom: 12 }}>Voltar</Button>

      <Card>
        <Title level={3}><PlusOutlined /> Novo time</Title>
        <Alert
          type="info" showIcon style={{ marginBottom: 16 }}
          message="Sem trial — cobrança começa em 30 dias"
          description="Times adicionais entram já como assinantes ativos. Você recebe o link de pagamento pela sua conta."
        />

        <Form form={form} layout="vertical" onFinish={submit} initialValues={{ players: 15, goalkeepers: 2 }}>
          <Form.Item name="team_name" label="Nome do time" rules={[{ required: true, message: 'Coloca o nome' }]}>
            <Input placeholder="Pelada do Trampo" maxLength={80} />
          </Form.Item>

          <Form.Item name="day_of_week" label="Dia da semana" rules={[{ required: true }]}>
            <Select placeholder="Escolhe o dia" options={DOWS} />
          </Form.Item>

          <Form.Item name="game_time" label="Horário do jogo" rules={[{ required: true }]}>
            <TimePicker format="HH:mm" style={{ width: '100%' }} minuteStep={5} />
          </Form.Item>

          <div style={{ display: 'flex', gap: 12 }}>
            <Form.Item name="players" label="Jogadores de linha" style={{ flex: 1 }}>
              <InputNumber min={4} max={30} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name="goalkeepers" label="Goleiros" style={{ flex: 1 }}>
              <InputNumber min={0} max={4} style={{ width: '100%' }} />
            </Form.Item>
          </div>

          <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 12 }}>
            Depois de criar, você é levado direto pro painel do time novo. Configurações extras
            (dias adicionais, horários) podem ser editadas em Configuração.
          </Text>

          <Button type="primary" htmlType="submit" size="large" loading={loading} block
            style={{ background: '#25D366', borderColor: '#25D366', fontWeight: 700 }}>
            Criar time
          </Button>
        </Form>
      </Card>
    </div>
  );
}
